






































































import Vue, { PropType } from 'vue'

export default Vue.extend({
  data () {
    return {
      showMenu: false
    }
  },

  computed: {
    imgTitle () {
      return this.$gettext('Change interface language')
    }
  },

  methods: {
    toggleShow () {
      this.showMenu = !this.showMenu;
    },
    buildLanguageRoute(locale: string) {
      const paths = this.$route.fullPath.split('/')

      if (paths.length > 0 && this.$language.available.hasOwnProperty(paths[0])) {
        return "/" + locale + "/" + paths.slice(1).join("/")
      } else {
        return "/" + locale + this.$route.fullPath
      }
    }
  }
})
